import { render, staticRenderFns } from "./VociExtraOrdine.vue?vue&type=template&id=2423894f&"
import script from "./VociExtraOrdine.vue?vue&type=script&lang=js&"
export * from "./VociExtraOrdine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports